@import '../../../constants/spacing.module.less';

.banner-content {
  flex: 1;
  align-items: center;
}

.banner-text {
  height: 24px;
}

.apply-button {
  display: flex;
  padding: @space-8 @space-12;
  align-items: center;
  gap: @space-8;
}

.apply-button-icon {
  width: 16px;
  height: 16px;
  padding: 2.667px; // figma icon padding
}
